import {useIntl} from "react-intl";
import {withTooltip} from "react-tippy";
import React from "react";
import {SurveyOldVersionWarningProps} from "./types";
import Alert from "@ui-components/Alert";

export const SurveyOldVersionWarning = ({
  type,
  name,
  version,
  latest,
}: SurveyOldVersionWarningProps) => {

  // check type consistency
  if (!["badge", "alert"].includes(type))
    throw new Error("Invalid type provided to SurveyOldVersionWarning component");

  // hooks
  const intl = useIntl();

  // utils
  const title = intl.formatMessage({
    id: "survey_old_version_title",
    defaultMessage: "Configurazione obsoleta",
  });
  const message = intl.formatMessage({
    id: "survey_old_version_message",
    defaultMessage: "Questa configurazione è stata creata con una versione passata del configuratore \"{name}\" (utilizzata V{version}, attuale V{latest})",
  }, {name, version, latest});

  // --- Renderers

  // If provided version is undefined, return null
  if (version === undefined)
    return null;

  // If the version is already the latest or the logged user can't access Explorer, return null
  if (version === latest)
    return null;

  if (type === "alert")
    // @ts-ignore
    return <Alert type="neutral" title={title} text={message} />

  // If the version is not the latest, return the icon with a tooltip that explains it
  const tooltipRenderer = withTooltip(
    () => (
      <div className="text-xxs bg-gray-300 py-0.5 px-1 rounded select-none">
        OLD
      </div>
    ),
    {
      title: message,
      distance: 20,
      animation: "fade",
      hideOnClick: true,
    }
  );

  // @ts-ignore
  return tooltipRenderer();
}